import { render } from "./MenuItemReports.vue?vue&type=template&id=f6b4e066"
import script from "./MenuItemReports.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuItemReports.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/MenuItemReports.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f6b4e066"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f6b4e066', __exports__)) {
    api.reload('f6b4e066', __exports__)
  }
  
  module.hot.accept("./MenuItemReports.vue?vue&type=template&id=f6b4e066", () => {
    api.rerender('f6b4e066', render)
  })

}


export default __exports__